module.exports = __webpack_public_path__ + "media/src/images/arrow__questionBack-a3a0ae4bb89bb31a786da1364be96c59.png";